import React from "react";
import cerrar from "../../assets/vw/svg/cerrar.svg";
import warningIcon from "../../assets/vw/svg/warning-icon.svg";

const ModalWarning = ({
    active = false,
    title = "¿Estás seguro?",
    message = "",
    confirmText = "Eliminar",
    cancelText = "Cancelar",
    onConfirm = () => {},
    onCancel = () => {},
}) => {
    if (!active) return null;

    const handleConfirm = async () => {
        await onConfirm();
        onCancel();
    };

    return (
        <div
            className="modal modal_vw modal_popup_vw fade show"
            id="modal-warning"
            data-keyboard="false"
            data-backdrop="static"
            tabIndex="-1"
            aria-labelledby="modalWarningLabel"
            style={{ display: "block" }}
            aria-modal="true"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered modal_popup_content">
                <div className="modal-content modal_content-vw">
                    <div className="modal_header-vw">
                        <div className="d-flex justify-content-end m-2">
                            <button
                                className="button_icon-vw"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={onCancel}
                            >
                                <img src={cerrar} alt="cerrar" />
                            </button>
                        </div>
                    </div>
                    <div className="modal-body p-3 pt-sm-0">
                        <div className="mt-0 mt-lg-2 mensaje_confirmacion mb-0 px-5 pb-5 pt-2">
                            <div className="d-flex justify-content-center">
                                <img src={warningIcon} className="icono-mensaje" alt="advertencia" />
                            </div>
                            <label className="popup_title popup_title--status modal_warning-title d-flex justify-content-center">
                                {title}
                            </label>
                            <div className="modal_warning-body text-center mb-3">
                                {String(message).split("\n").map((line) => (
                                    <p className="mb-1" key={line}>{line}</p>
                                ))}
                            </div>
                            <button
                                type="button"
                                className="button_vw button_vw--secondary mr-2 mb-2 order-2 order-sm-1 mt-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={onCancel}
                            >
                                {cancelText}
                            </button>
                            <button
                                type="button"
                                className="button_vw button_vw--delete mb-2 order-1 order-sm-2 mt-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleConfirm}
                            >
                                {confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalWarning;
